import React, { useState, useEffect } from "react";
import { socket } from "../../io";
import "./footer.css";

const Hour = ({ num, active }) => {
  const [hour, setHour] = useState(0);
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    let intervalId = null;

    const handler = (data) => {
      if (intervalId) clearInterval(intervalId);

      intervalId = setInterval(() => {
        const actualHr = Math.floor(Date.now() / 1000);
        const timeLess = data.hour - actualHr;
        setHour(timeLess > 0 ? timeLess : 0);
      }, 1000);
    };

    socket.on("hour", handler);

    const clockId = setInterval(() => {
      setNow(new Date());
    }, 1000);

    return () => {
      socket.off("hour", handler);
      if (intervalId) clearInterval(intervalId);
      clearInterval(clockId);
    };
  }, []);

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const sec = (seconds % 60).toString().padStart(2, "0");
    return `${min}:${sec}`;
  };

  const formatClock = (date) => {
    return date.toLocaleTimeString("en-GB", {
      hour12: false,
    });
  };

  const formatDate = (date) => {
    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .toUpperCase();
  };

  return (
    <div className="header-clock-chip">
      {active ? (
        <>
          <span className="header-clock-top">
            PRÓXIMO #{num?.toString().padStart(4, "0")}
          </span>
          <span className="header-clock-bottom">
            {formatTime(hour)}
          </span>
        </>
      ) : (
        <>
          <span className="header-clock-top">{formatClock(now)}</span>
          <span className="header-clock-bottom">{formatDate(now)}</span>
        </>
      )}
    </div>
  );
};

export default Hour;